import {
  AfterViewInit,
  Component,
  computed,
  ElementRef,
  inject,
  signal,
  ViewChild,
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { WishListService } from '../../services/wish-list.service';
import { Catalog } from '../../../rewards/interfaces/search-catalog-response.interface';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { ModalService } from '../../services/modal.service';
import { FormUtils } from '@utilities/classes/form-utils';
import { WishListDataService } from '../../../core/services/witsh-list-data.service';

@Component({
  selector: 'app-create-new-wishlist-modal',
  imports: [ReactiveFormsModule],
  templateUrl: './create-new-wishlist-modal.component.html',
})
export class CreateNewWishlistModalComponent implements AfterViewInit {
  @ViewChild('focusAnchor', { static: true })
  focusAnchor!: ElementRef<HTMLElement>;

  ngAfterViewInit(): void {
    this.focusAnchor.nativeElement.focus();
  }
  private ngbActiveModal = inject(NgbActiveModal);
  private wishlistService = inject(WishListService);
  private modalService = inject(ModalService);
  private wishListDataService = inject(WishListDataService);

  formUtils = FormUtils;
  article = signal<Catalog | null>(null);
  control = new FormControl('', [
    Validators.required,
    Validators.minLength(5),
    Validators.maxLength(70),
  ]);

  closeModal() {
    this.ngbActiveModal.dismiss();
  }

  saveWishList() {
    if (this.control.invalid) {
      this.control.markAllAsTouched();
      return;
    }

    const detailCatalogId = this.article()!.detailCatalogs[0].detailCatalogId;
    const wishListName = this.control.value!;

    this.wishlistService
      .createWishList(detailCatalogId, wishListName)
      .subscribe({
        next: (isSuccess) => {
          if (isSuccess) {
            this.closeModal();
            this.wishListDataService.getWishList();
            this.modalService.saveArticleInWishList(
              this.article()!,
              wishListName,
            );
          }
        },
      });
  }
}
